import React from 'react';
import { Route, Navigate } from 'react-router-dom';

// Layout
import DPLLayout from '../layouts/DPLLayout';

// Components
import ProtectedRoute from '../Components/ProtectedRoute';

// Pages
import DPLDashboard from '../Pages/Dpl/Dashboard';
import MonitoringVECI from '../Pages/Dpl/MonitoringVECI';
import MonitoringBMC from '../Pages/Dpl/MonitoringBMC';
import Escalations from '../Pages/Dpl/Escalations';

const dplRoutes = () => (
  <Route path='dpl'>
    {/* semua halaman setelah login, hanya role DPL yg bisa akses */}
    <Route element={<ProtectedRoute allowedRoles={['DPL']} />}>
      <Route element={<DPLLayout />}>
        <Route index element={<DPLDashboard />} />
        <Route path='home' element={<Navigate to='/dpl' replace />} />
        <Route path='monitoring-veci' element={<MonitoringVECI />} />
        <Route path='monitoring-bmc' element={<MonitoringBMC />} />
        <Route path='escalations' element={<Escalations />} />
      </Route>
    </Route>
  </Route>
);

export default dplRoutes;
